export default "__VITE_ASSET__3vXm2QiI__"